"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../../openapi");
const Common = __importStar(require("../../common"));
const Events = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Events.Spec';
/*
 * `routes/v2/api/fleet/events/router.js`: `[read, satCredentialRouteGuard]`,
 * controller on protocol v1 with express-validator.
 */
// Query struct intentionally has no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const ListQuery = effect_1.Schema.Struct({
    deviceId: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Serial number of the device',
    }),
    dateRangeStart: effect_1.Schema.propertySignature(Common.NonNegativeIntFromString).annotations({
        description: 'Range start, Unix ms',
    }),
    dateRangeEnd: effect_1.Schema.propertySignature(Common.NonNegativeIntFromString).annotations({
        description: 'Range end, Unix ms. Meant to exceed dateRangeStart, but the controller does not enforce it (see the operation description).',
    }),
});
const list = platform_1.HttpApiEndpoint.get('listFleetEvents') ``
    .setUrlParams(ListQuery)
    .addSuccess(openapi_1.Response.Success(Events.EventHistory).annotations({
    description: 'Events grouped by day',
}))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'List Device Events')
    .annotate(platform_1.OpenApi.Description, 'Returns the events of one device in the range, grouped per UTC day from `dateRangeEnd` backwards. ' +
    'Answers 422 when a parameter is missing or not a non-negative integer, 401 when a SAT does not grant `deviceId`. ' +
    'Known runtime quirks: the `dateRangeEnd > dateRangeStart` rule never fires (its `custom()` check returns a validation chain, which always passes), so an equal range or an end less than a day before the start answers 200 with no items and an end a day or more before the start answers a v1 500; ' +
    'an unknown `deviceId` is also a v1 500, not the 404 the controller intends, because the repository lookup throws outside its `try`.')
    .pipe(Common.withReadOrSatGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.fleet.events')
    .add(list)
    .prefix('/fleet/events')
    .annotate(platform_1.OpenApi.Title, 'Fleet Events')
    .annotate(platform_1.OpenApi.Description, 'Event history of one device, grouped per day')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Fleet));
//# sourceMappingURL=spec.js.map